export function featuresContent() {
  const container = document.querySelector('.home-features__items');
  const feature = document.querySelectorAll('.home-features__items .home-features__item');

  window.addEventListener('load', resizeListener);
  window.addEventListener('resize', resizeListener);

  function resizeListener() {
    let containerHeight = 0;
    let sizes = [];
    const marginBottom = 50;
    let colOneSize = 200; // 1 column margin top
    let colTwoSize = 100; // 2 column margin top
    let colTreeSize = 0;
    let colSizes = [];

    feature.forEach((item) => {
      sizes.push(item.offsetHeight);
    });

    // 3 columns
    if (document.documentElement.clientWidth >= 1367) {
      feature.forEach((item, i) => {
        const order = i % 3;
        item.style.order = order;

        switch(item.style.order) {
          case '0':
            colOneSize = colOneSize + item.offsetHeight + marginBottom;
            colSizes.push(colOneSize);
            break;
          case '1':
            colTwoSize = colTwoSize + item.offsetHeight + marginBottom;
            colSizes.push(colTwoSize);
            break;
          case '2':
            colTreeSize = colTreeSize + item.offsetHeight + marginBottom;
            colSizes.push(colTreeSize);
            break;
        }
      });

      container.style.height = Math.max(...colSizes) + 'px';
    }
    // 2 columns
    else if (document.documentElement.clientWidth < 1367 && document.documentElement.clientWidth >= 768) {
      feature.forEach((item, i) => {
        const order = i % 2;
        item.style.order = order;

        switch(item.style.order) {
          case '0':
            colOneSize = colOneSize + item.offsetHeight + marginBottom;
            colSizes.push(colOneSize);
            break;
          case '1':
            colTwoSize = colTwoSize + item.offsetHeight + marginBottom;
            colSizes.push(colTwoSize);
            break;
        }
      });

      container.style.height = Math.max(...colSizes) + 'px';
    }
    // 1 columns
    else if (document.documentElement.clientWidth < 768) {
      sizes.forEach((item) => {
        containerHeight = containerHeight + (item + marginBottom);
      });

      container.style.height = (containerHeight) + 'px';
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featuresContent.js